import { styled } from "@mui/material/styles";
import Switch, { switchClasses } from "@mui/material/Switch";
import React from "react";

const CustomSwitch = styled(Switch)({
  width: 75,
  height: 38,
  padding: 8,
  transition: "ease-in-out 0.3s",
  [`& .${switchClasses.switchBase}`]: {
    padding: 11,
    color: "#ff6a00",
    transition: "ease-in-out 0.3s",
  },
  [`& .${switchClasses.thumb}`]: {
    width: 15,
    height: 15,
    backgroundColor: "#fff",
    transition: "ease-in-out 0.3s",
  },
  [`& .${switchClasses.track}`]: {
    background: "#d32f2f",
    opacity: "1 !important",
    borderRadius: 20,
    position: "relative",
    transition: "ease-in-out 0.3s",
    "&:before, &:after": {
      display: "inline-block",
      position: "absolute",
      top: "50%",
      width: "50%",
      transform: "translateY(-50%)",
      color: "#fff",
      textAlign: "center",
      fontSize: "0.75rem",
      fontWeight: 500,
      transition: "ease-in-out 0.3s",
      content: '""',
    },
    "&:before": { left: 4, opacity: 0 },
    "&:after": { right: 8 },
  },
  [`& .${switchClasses.checked}`]: {
    [`&.${switchClasses.switchBase}`]: {
      color: "#003366 !important",
      transform: "translateX(37px)",
      "&:hover": { backgroundColor: "rgba(24,90,257,0.08)" },
    },
    [`& .${switchClasses.thumb}`]: { backgroundColor: "#fff" },
    [`& + .${switchClasses.track}`]: {
      background: "#003366 !important",
      "&:before": { opacity: 1 },
      "&:after": { opacity: 0 },
    },
  },
  // ── Disabled overrides — Mui-disabled lives on switchBase, not root ────
  [`& .${switchClasses.disabled}`]: {
    [`&.${switchClasses.switchBase}`]: {
      color: "#bdbdbd !important",
    },
    [`& .${switchClasses.thumb}`]: {
      backgroundColor: "#f5f5f5 !important",
    },
    [`& + .${switchClasses.track}`]: {
      background: "#9e9e9e !important",
      opacity: "1 !important",
      "&:before, &:after": {
        color: "#fff !important",
      },
    },
  },
});

const ToggleSwitch = ({ checked, handleChange, disabled }) => {
  return (
    <>
      <CustomSwitch checked={checked} onChange={handleChange} disabled={disabled}
        sx={{
          marginTop: "-2px",
          [`& .${switchClasses.track}`]: {
            '&:before': {
              content: `"${checked ? 'Show' : 'Hide'}"`,
            },
            '&:after': {
              content: `"${checked ? 'Show' : 'Hide'}"`,
            },
          },
        }}
      />
    </>
  )
}

export default ToggleSwitch;
